import { render, staticRenderFns } from "./ScheduleTemplate.vue?vue&type=template&id=196365f5&"
import script from "./ScheduleTemplate.vue?vue&type=script&lang=js&"
export * from "./ScheduleTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports